import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const DashboardTopComponent = () => {
  const navigate = useNavigate();
  const handleImportUsingExcelTamplet = () => {};

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          columnGap: 1,
          alignItems: 'center',
        }}
      >
        <Typography variant='s24_w600' color='secondary'>
          Dashboard
        </Typography>
        {/* <Box
          sx={{
            padding: '0.65rem 1.6rem',
            border: '1px solid #46B52A',
            borderRadius: '5rem',
          }}
        >
          <Typography component='span' variant='s16_w500' color='secondary'>
            Active:
          </Typography>
          &nbsp;&nbsp;
          <Typography component='span' variant='s16_w700' color='secondary'>
            12
          </Typography>
        </Box>
        <Box
          sx={{
            padding: '0.65rem 1.6rem',
            border: '1px solid#F5825E',
            borderRadius: '5rem',
          }}
        >
          <Typography component='span' variant='s16_w500' color='secondary'>
            Drafts:
          </Typography>
          &nbsp;&nbsp;
          <Typography component='span' variant='s16_w700' color='secondary'>
            07
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          columnGap: 2,
          justifyContent: 'flex-end',
        }}
      >
        <Button variant='contained' onClick={handleImportUsingExcelTamplet}>
          Import using Excel template
        </Button> */}
      </Box>
    </Box>
  );
};

export default DashboardTopComponent;
